import { render, staticRenderFns } from "./ProfileBadgeEarnedModal.vue?vue&type=template&id=05edac22&"
import script from "./ProfileBadgeEarnedModal.vue?vue&type=script&lang=ts&"
export * from "./ProfileBadgeEarnedModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileBadgeEarnedModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports